import React from 'react'
import FundingCardContainer from './FundingCardContainer'

const FundingCard = props => (
  <FundingCardContainer {...props} data-test="component-stock-funding-card" />
)

export default FundingCard
